/**
 * Sprint 156 — El enlace con el que la pantalla despierta al programa de la caja.
 *
 * Vive en `shared` por una razón concreta: lo escriben dos lados distintos —el
 * programa de la caja lo registra en Windows, y la pantalla de venta lo dispara—
 * y si los dos textos se separan por una letra, el botón "Encender la impresora"
 * no hace absolutamente nada y nadie se entera hasta que falte un ticket. Un solo
 * lugar, y una prueba que lo vigila.
 *
 * Este archivo **no importa nada**: el instalador del agente lo copia suelto
 * (igual que `escposBuilder`), y cualquier dependencia nueva aquí lo rompería en
 * la computadora del negocio, no en el build.
 */

/** Esquema propio registrado en Windows por el instalador del agente. */
export const ESQUEMA_AGENTE = 'restaurantpos';

/**
 * Lo único que el enlace sabe hacer: abrir el programa.
 *
 * Deliberadamente no lleva datos. Un esquema registrado lo puede invocar
 * cualquier página web, así que lo peor que puede conseguir un sitio hostil es
 * que se abra una ventana en la caja.
 */
export const ENLACE_DESPERTAR_AGENTE = `${ESQUEMA_AGENTE}://abrir`;
